<template>
  <div class="body-login d-flex justify-content-center align-items-center ">
    <div class=" fadeInDown ">
      <div class="content px-4">
        <div class="text-center">
          <img alt="Vue logo" src="@/assets/logo.png" class="login-logo " />
        </div>
        <b-form @submit="makeLogin($event)">
          <b-form-group
            id="email-group"
            :label="$t('user.username')"
            label-for="email"
            class="left">
            <b-form-input
              v-model="form.email"
              id="email"
              type="text"
              required
              :placeholder="$t('user.enterUsername')"
              :class="{'is-invalid': validation}"/>
          </b-form-group>

          <b-form-group
          id="password-group"
          :label="$t('user.password')"
          label-for="password"
          class="left"
          >
          <GwPassword v-model="form.password" :g-required="true" :g-placeholder="$t('user.enterPassword')"
                      :g-class="validation ? 'error' : '' " />
          </b-form-group>

          <b-button id="btn-login" block type="submit" variant="primary" :disabled="loading" class="w-50 center-m">
            <span
              class="spinner-border spinner-border-sm"
              v-show="loading"
            />
            {{$t('login.login')}}
          </b-button>
        </b-form>
        <p class="text-center mt-4">
          <router-link to="/forgot-password" v-text="$t('login.forgotPassword')" ></router-link>
        </p>
      </div>
      <p class="text-center my-3 link-white">
        <a :href=" desktopVersionLink " v-text="$t('login.goToDesktopVersion')"></a>
      </p>
    </div>

  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';
import { Login } from '@/api/api';
import GwPassword from '@/components/gwPassword/GwPassword.vue';

export default {
  name: 'Login',
  components: {
    GwPassword
  },
  data() {
    return {
      desktopVersionLink: `${process.env.VUE_APP_LINK_DESKTOP_VERSION}?stay-desktop-version=true`,
      form: {
        email: '',
        password: '',
      },
      loading: false,
      validation: false,
    };
  },
  methods: {
    makeLogin(e) {
      this.loading = true;
      e.preventDefault();
      
      Login(this.form).then((data) => {
          if (data.jwt) {
            const decoded = jwtDecode(data.jwt);
            const user = decoded.identity;

            localStorage.setItem('jwt', data.jwt);
            localStorage.setItem('exp', decoded.exp);
            this.$store.commit('setUser', user);
            this.$store.commit("setUserCourses", data.courses);
            this.$store.commit('setMenuPolicy', data.menu.sort(function(a, b) { return (a.orden == b.orden) ? 0 : ( (a.orden > b.orden) ? 1 : -1 )} ));
            this.$store.commit('setLogged', true);
            
            let defaultCourse = null;
            
            this.G_changeLanguage(user.language)
            data.courses.find((course) => {
              if (user.default_course_id == course.course_id) {
                defaultCourse = course;
              }
            });
            defaultCourse = defaultCourse ? defaultCourse : data.courses[0];
            
            this.$store.commit("setCourse", defaultCourse);

            let lang = '';
            switch (user.language) {
              case 'en':
              case 'en_au':
              case 'en_nz':
              case 'en_uk':
              case 'en_ca':
              case 'en_id':
              case 'en_my':
              case 'en_mm':
              case 'en_sg':
              case 'en_th':
              case 'en_vn':
              case 'en_st':
                lang = 'en';
                break;
              case 'es':
                lang = 'es';
                break;
            }
            
            this.$i18n.locale = lang ? lang : this.$i18n.locale;
            this.$router.push('/dashboard');
          }
          this.loading = false;
        })
        .catch((e) => {
          this.validation = true;
          this.loading = false;
        });
    },
  },
   mounted() {
    this.$i18n.locale= 'en';
  },
};

</script>
<style lang="scss" src='./Login.scss' scoped ></style>
